<template>
  <div class="incompleted-list">
    <div v-if="incompletedList.length > 0" class="list">
      <div
        v-for="item in incompletedList"
        class="item"
        :class="
          item.ID === selectedID
            ? 'selected'
            : item.state === 3 && item.operatorUID !== uID
            ? 'occupied'
            : ''
        "
        :key="item.ID"
        @click="selectPay(item.ID, true, false)"
      >
        <div :title="item.paymentDate">{{ item.paymentDate }}</div>
        <div :title="item.paymentTime">{{ item.paymentTime }}</div>
        <br />
        <div class="company" :title="item.companyName">
          {{ item.companyName }}
        </div>
        <div :title="`${item.divisionID}, ${item.deviceID}`">
          {{ item.address }}, {{ item.place }}
        </div>
      </div>
    </div>
    <div v-else>
      조회 내역이 없습니다.
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';

export default {
  props: ['tab', 'selectedID', 'refreshEvent', 'uID'],
  data: () => ({
    stateQuery: '',
    incompletedList: [],
    loading: true,
    interval: null,
  }),
  created() {
    this.getIncompletedList(false, false);
    this.interval = setInterval(() => {
      if (!this.loading) {
        this.getIncompletedList(true, false);
      }
    }, 5000);
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  watch: {
    tab: {
      handler() {
        if (this.tab === 'pending') {
          this.stateQuery = 'state=8&state=11';
        } else {
          this.stateQuery = 'state=2&state=3';
        }

        this.getIncompletedList(false, true);
      },
      immediate: true,
    },
    refreshEvent() {
      if (!this.loading) {
        this.getIncompletedList(false, false);
      }
    },
  },
  methods: {
    async getIncompletedList(polling, tabChange) {
      this.loading = true;
      if (!polling) {
        this.incompletedList = [];
      }

      try {
        const incompletedList = [];
        for (let i = 1; ; i++) {
          const res = await this.$http.get(
            `${Configuration.value(
              'CPAYMENT_ADDRESS',
            )}/api/v1/cpayment/payment/list?${
              this.stateQuery
            }&approveResult=3&limit=500&page=${i}&order=2&polling=${polling}`,
            {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
              },
            },
          );
          if (res.status !== 200) {
            if (res.status === 204) {
              break;
            }
            throw new Error(`Response status is "${res.status}"`);
          }
          if (res.data.resultCode !== '0000') {
            throw new Error(`ResultCode is "${res.data.resultCode}"`);
          }

          for (let j = 0; j < res.data.payments.length; j++) {
            const p = res.data.payments[j];
            let paymentDetail = null;
            if (p.paymentDetails && p.paymentDetails.length > 0) {
              paymentDetail = `${p.paymentDetails[0].productName.substr(0, 2)}+${p.paymentDetails.length}`;
            }

            const payment = {
              ID: p.paymentID,
              paymentDate: this.$moment(p.paymentAt).format('YYYY.MM.DD'),
              // paymentTime: this.$moment(p.paymentAt).format('hh:mm A'),
              paymentTime: this.$moment(p.paymentAt).format('HH:mm:ss'),
              paymentDetail: paymentDetail || '-',
              approveResult: p.approveResult,
              approvePrice: p.approvePrice
                ? `${p.approvePrice.toLocaleString()}원`
                : '-',
              resultCode: p.resultCode ? p.resultCode : '-',
              state: p.state ? p.state : '-',
              paymentMode: p.paymentMode ? p.paymentMode : '-',
              address: p.address ? p.address : '-',
              place: p.place ? p.place : '-',
              divisionID: p.divisionID ? p.divisionID : '-',
              deviceID: p.deviceID ? p.deviceID : '-',
              companyName: p.companyName ? p.companyName : '-',
              operatorUID: p.operatorUID ? p.operatorUID : '-',
            };
            incompletedList.push(payment);
          }
        }

        this.incompletedList = incompletedList;

        if (tabChange || !this.selectedID) {
          if (this.incompletedList.length > 0) {
            for (let k = 0; k < this.incompletedList.length; k++) {
              if (
                (this.incompletedList[k].state === 2 || (this.incompletedList[k].state === 3 && this.incompletedList[k].operatorUID === this.uID)) || // 불완전결제
                (this.incompletedList[k].state === 8 || (this.incompletedList[k].state === 11 && this.incompletedList[k].operatorUID === this.uID)) // 보류
              ) {
                this.selectPay(this.incompletedList[k].ID, false, polling);
                break;
              }
            }
          } else {
            this.$emit('selectPay', null);
          }
        }

        this.loading = false;
      } catch (e) {
        this.loading = false;
        if (!polling) {
          this.incompletedList = [];
          alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        }

        console.error(e);
      }

      if (!polling) {
        this.$nextTick(this.scrollToSelected);
      }
    },
    selectPay(ID, reload, polling) {
      if (!ID) {
        return;
      }

      this.$emit('selectPay', ID);
      if (reload) {
        this.getIncompletedList(polling);
      }
    },
    scrollToSelected() {
      if (!this.selectedID) {
        return;
      }

      const element = document.getElementsByClassName('selected');
      if (element.length !== 1) {
        return;
      }
      const target = element[0];

      target.parentNode.scrollLeft = target.offsetLeft - 180;
    },
  },
};
</script>

<style scoped>
.list {
  display: flex;
  margin-top: 24px;
  width: 100%;
  height: 110px;
  overflow-x: auto;
}
.list::-webkit-scrollbar-corner {
  background-color: inherit;
}
.list::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.list::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #4082f3;
}
.list::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.list .item {
  padding: 12px;
  min-width: 128px;
  width: 128px;
  height: 98px;
  font-size: 10px;
  line-height: 1.2;
  letter-spacing: -0.19px;
  color: #9d9ea1;
  border-radius: 2px;
  border: solid 0.5px #9d9ea1;
  cursor: pointer;
  transition: 0.2s;
}
.list .item.selected {
  border: solid 2px #0058ee;
}
.list .item.occupied {
  border: solid 1px red;
}
.list .item:not(:last-of-type) {
  margin-right: 8px;
}
.list .item:hover {
  background-color: #f0f0f0;
}
.list .item div {
  max-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list .item .company {
  font-weight: bold;
  color: #4082f3;
}
</style>



// WEBPACK FOOTER //
// src/components/incompletedPay/IncompletedList.vue